import { Component, OnInit, Input, Inject, EventEmitter, Output } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { PropertyService } from '../../../../property';
import { AlertService } from '../../../../../_services';
import { ApiResponse } from '../../../../../_models';
import { Feature } from '@app/_components/property/feature';
import { FeatureService } from '@app/_components/property/feature';
import { BedroomService } from '../../bedroom.service';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
    selector: 'app-bedroom-form',
    templateUrl: './bedroom-form.component.html',
    styleUrls: ['./bedroom-form.component.css'],
    standalone: false
})
export class BedroomFormComponent implements OnInit
{



	constructor(private router: Router,
		private activatedRoute: ActivatedRoute,
		private bedroomService: BedroomService,
		private featureService: FeatureService,
		private alertService: AlertService,
		private location: Location,
		private formBuilder: UntypedFormBuilder,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) data)
	{
		this.shortTermRentalId = data.shortTermRentalId;
	}


	@Input() shortTermRentalId: number;
	@Input() featuresList = [];
	@Input() bedroom: any;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	apiResponse: ApiResponse;
	bedroomId: number;


	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAction: String;
	formLabels = [];
	formReadOnly = false;
	formAlert: String;
	formTitle: String;

	bedroomNames = [
		{ value: 'BD1', name: 'Bedroom 1 (Master)' },
		{ value: 'BD2', name: 'Bedroom 2' },
		{ value: 'BD3', name: 'Bedroom 3' },
		{ value: 'BD4', name: 'Bedroom 4' },
		{ value: 'BD5', name: 'Bedroom 5' },
		{ value: 'BD6', name: 'Bedroom 6' },
		{ value: 'BD7', name: 'Bedroom 7' },
		{ value: 'BD8', name: 'Bedroom 8' },
		{ value: 'BD9', name: 'Bedroom 9' },
		{ value: 'BD10', name: 'Bedroom 10' },
		{ value: 'BD11', name: 'Bedroom 11' },
		{ value: 'BD12', name: 'Bedroom 12' },
	];

	bedroomTypes = [
		{ value: 'BT', name: 'Traditional' },
		{ value: 'BL', name: 'Loft' },
		{ value: 'BD', name: 'Den' },
		{ value: 'BO', name: 'Other' },
	];

	accessVias = [
		{ value: 'HA', name: 'Hall' },
		{ value: 'BD', name: 'Other Bedroom' },
		{ value: 'HB', name: 'Hall or Other Bedroom' },
		{ value: 'GA', name: 'Garage' },
		{ value: 'OU', name: 'Outside' },
		{ value: 'OT', name: 'Other' },
	];

	bathroomAccessTypes = [
		{ value: 'NB', name: 'No Attached Bathroom' },
		{ value: 'BA1', name: 'Bathroom 1 (Master)' },
		{ value: 'BA2', name: 'Bathroom 2' },
		{ value: 'BA3', name: 'Bathroom 3' },
		{ value: 'BA4', name: 'Bathroom 4' },
		{ value: 'BA5', name: 'Bathroom 5' },
		{ value: 'BA6', name: 'Bathroom 6' },
		{ value: 'BA7', name: 'Bathroom 7' },
		{ value: 'BA8', name: 'Bathroom 8' },
		{ value: 'BA9', name: 'Bathroom 9' },
		{ value: 'BA10', name: 'Bathroom 10' },
		{ value: 'BA11', name: 'Bathroom 11' },
		{ value: 'BA12', name: 'Bathroom 12' },
	];

	viewTypes = [
		{ value: 'NV', name: 'No View' },
		{ value: 'GGV', name: 'Garden View' },
		{ value: 'RV', name: 'Resort View' },
		{ value: 'BF', name: 'Beach Front' },
		{ value: 'BV', name: 'Beach View' },
		{ value: 'BP', name: 'Beach View Partial' },
		{ value: 'OF', name: 'Ocean Front' },
		{ value: 'OV', name: 'Ocean View' },
		{ value: 'OP', name: 'Ocean View Partial' },
		{ value: 'PK', name: 'Ocean View Peakaboo' },
		{ value: 'LF', name: 'Lake Front' },
		{ value: 'LV', name: 'Lake View' },
		{ value: 'LVP', name: 'Lake View Partial' },
		{ value: 'MV', name: 'Mountain' },
		{ value: 'PMV', name: 'Partial Mountain' },
		{ value: 'TRE', name: 'Tree' },
		{ value: 'VAL', name: 'Valley' },
		{ value: 'STR', name: 'Street' },
		{ value: 'HIL', name: 'Hill' },
		{ value: 'CIT', name: 'City' },
		{ value: 'GF', name: 'Golf Course Front' },
		{ value: 'GV', name: 'Golf Course View' },
		{ value: 'GP', name: 'Golf Course View Partial' },
		{ value: 'SK', name: 'Ski In Out' }
	];

	airConditioningTypes = [
		{ value: 'NA', name: 'None ' },
		{ value: 'WM', name: 'Wall-Mounted A/C' },
		{ value: 'SZ', name: 'Single Zone A/C' },
		{ value: 'MZ', name: 'Multiple Zone A/C' },

	];

	validationMessages = {
		'shortTermRentalId': [],
		'description': [],
		'consumablesDesc': [],
		'name': [],
		'bedroomType': [],
		'accessVia': [],
		'bathroomAccessType': [],
		'viewType': [],
		'airConditioningType': [],
		'sleepsMax': [],
		'sleepsMaxInBeds': [],
	};

	ngOnInit()
	{
		this.formBuild();
		if (this.bedroom)
		{
			this.form1.patchValue(this.bedroom);
			this.bedroomId = this.bedroom.bedroomId;
		}
	}


	formAdd()
	{
		try
		{
			// stop here if form is invalid
			if (this.form1.invalid)
			{
				return;
			}

			this.formLoading = true;
			this.bedroomService.add(this.form1.value)
				.subscribe(
					res =>
					{
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
						this.bedroom = res.data.bedroom;
						this.doAdd.emit(this.bedroom);

					},
					err =>
					{
						console.log('bedroom-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}


	formUpdate()
	{
		console.log('bedroom: ' + JSON.stringify(this.form1.value));
		try
		{
			// stop here if form is invalid
			if (this.form1.invalid)
			{
				return;
			}
			this.formLoading = true;

			this.bedroomService.update(this.form1.value)
				.subscribe(
					res =>
					{
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
						this.bedroom = res.data.bedroom;
						this.doUpdate.emit(this.bedroom);
					},
					err =>
					{
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error)
		{
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete()
	{
		try
		{
			// stop here if form is invalid
			if (this.form1.invalid)
			{
				return;
			}

			this.formLoading = true;

			this.bedroomService.delete(this.bedroom.bedroomId)
				.subscribe(
					res =>
					{
						console.log('bedroom-delete SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
						this.doDelete.emit(this.bedroom);
					},
					err =>
					{
						console.log('bedroom-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}

	formBuild()
	{
		/**
				   *
				   *
				   *
				   * FORM
				   *
				   */

		this.form1 = this.formBuilder.group({
			shortTermRentalId: [this.shortTermRentalId],
			bedroomId: [this.bedroomId],
			name: ['', Validators.required],
			bedroomType: ['', Validators.required],
			accessVia: ['', Validators.required],
			bathroomAccessType: ['', Validators.required],
			viewType: ['', Validators.required],
			airConditioningType: ['', Validators.required],
			sleepsMax: ['', Validators.required],
			sleepsMaxInBeds: ['', Validators.required],
			description: [],
			consumablesDesc: [],
		});
	}
}
